import {Component, Pipe, PipeTransform, Injectable} from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'sortByParam',
    pure: false
})
@Injectable()
export class SortByParam implements PipeTransform {

    transform(items: any[], param: string): any {
        if (!items) return [];
        if (!param) return items;
        return items.sort(function(a,b) {return (a[param] > b[param]) ? 1 : ((b[param] > a[param]) ? -1 : 0);} );
    }
}
